export default "__VITE_ASSET__CTa7fV76__"